// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterInvitationsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  InviteCoapplicantWebApiRequestDto,
  InviteCoapplicantWebApiResponseDto,
  RemoveCoapplicantWebApiRequestDto,
} from '../..';

export const CappsRenterInvitationsWebApiHandler_inviteCoapplicant_Path =
  '/api/web/renter/v1/invitations/inviteCoapplicant';

export const CappsRenterInvitationsWebApiHandler_inviteCoapplicant = (
  postData: InviteCoapplicantWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, InviteCoapplicantWebApiRequestDto, InviteCoapplicantWebApiResponseDto>(
    {
      endpoint: CappsRenterInvitationsWebApiHandler_inviteCoapplicant_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterInvitationsWebApiHandler_removeCoapplicant_Path =
  '/api/web/renter/v1/invitations/removeCoapplicant';

export const CappsRenterInvitationsWebApiHandler_removeCoapplicant = (
  postData: RemoveCoapplicantWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RemoveCoapplicantWebApiRequestDto, void>(
    {
      endpoint: CappsRenterInvitationsWebApiHandler_removeCoapplicant_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
